import styled, { css } from "styled-components";

export const Flex = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`

export const Title = styled("div")`
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
`;

export const Text = styled("p")`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin: 16px 0px 32px;
`;

export const SmallMessage = styled('p')`
    text-align: center;
    margin: 0px;
    font-size: 14px;
    line-height: 18px;
`

export const AlignCenter = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
